import {type ISystemGroup, GroupType} from '../schema';
import {canManageSystemGroups} from './canManageSystemGroups';

export const canManageSystemGroupUsers = (group?: ISystemGroup) =>
	!!group && group.type !== GroupType.EVERYONE && canManageSystemGroups();
